"use client"

import useCommonStore from '@/store/commonStore';
import React from 'react'
import { ChevronRight } from 'lucide-react';

export default function ProfileSidebar({
  navItems,
  activeTab,
  setActiveTab,
  className = '',
  translations
}: {
  navItems: { label: string; key: string }[]
  activeTab: string | null
  setActiveTab: (key: string) => void
  className?: string
  translations:any
}) {
  const {logout} = useCommonStore()

  return (
    <aside className={`w-72 bg-[#F3FCFC] p-8 ${className}`}>
      <nav className="flex flex-col gap-2">
        {navItems.map(item => (
          <button
            key={item.key}
            className={`text-start py-2 rounded transition flex justify-between relative ${
              activeTab === item.key
                ? 'text-black before:absolute before:right-5 before:top-5 before:bottom-0 before:w-5 before:h-[1px] before:bg-gray-500 rtl:before:left-5 rtl:before:right-auto'
                : 'text-gray-400 hover:text-black'
            }`}
            onClick={() => setActiveTab(item.key)}
            aria-current={activeTab === item.key ? 'page' : undefined}
          >
            {item.label}
            {activeTab === item.key && <ChevronRight className='rtl:rotate-180'/>}
          </button>
        ))}
        <button
          className={`text-start py-2 rounded transition font-medium text-gray-700 hover:bg-gray-100`}
          onClick={() => logout()}
        >
          {translations["logout"]||'Logout'}
        </button>
      </nav>
    </aside>
  )
}